import {
  FETCH_DEFAULT_SCORING_CONFIG,
  FETCH_DEFAULT_SCORING_CONFIG_SUCCESS,
  FETCH_DEFAULT_SCORING_CONFIG_FAIL,
  SAVE_DEFAULT_SCORING_CONFIG,
  SAVE_DEFAULT_SCORING_CONFIG_SUCCESS,
  SAVE_DEFAULT_SCORING_CONFIG_FAIL,
  DEFAULT_SCORING_CONFIG_CLEAR
} from '../../actions/trm/defaultScoringConfig';

const initialState = {
  data: null,
  loading: false,
  saving: false,
  error: null,
  lastSavedAt: null
};

export default function defaultScoringConfig(
  state = initialState,
  action = {}
) {
  switch (action.type) {
    case FETCH_DEFAULT_SCORING_CONFIG:
      return { ...state, loading: true, error: null };
    case FETCH_DEFAULT_SCORING_CONFIG_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_DEFAULT_SCORING_CONFIG_FAIL:
      return { ...state, loading: false, error: action.payload };
    case SAVE_DEFAULT_SCORING_CONFIG:
      return { ...state, saving: true, error: null };
    case SAVE_DEFAULT_SCORING_CONFIG_SUCCESS:
      return {
        ...state,
        saving: false,
        data: action.payload,
        lastSavedAt: Date.now()
      };
    case SAVE_DEFAULT_SCORING_CONFIG_FAIL:
      return { ...state, saving: false, error: action.payload };
    case DEFAULT_SCORING_CONFIG_CLEAR:
      return initialState;
    default:
      return state;
  }
}
